﻿import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
/**
 * Hook to delete a user document.
 * Uses the mutations.deleteUserDocument mutation.
 */
export const useDeleteUserDocument = () => {
  const [deleteUserDocument, { data, loading, error }] = useMutation<any>(
    mutations.deleteUserDocument,
  );

  const deleteDocument = async (documentId: string) => {
    const result = await deleteUserDocument({
      variables: {
        documentId,
      },
    });

    return result.data.deleteUserDocument;
  };

  return { deleteDocument, data, loading, error };
};
